"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var convertHexToRgba = function convertHexToRgba(color, opacity) {
  var removeHash = color.replace("#", "");
  var hex = removeHash.length === 3 ? removeHash + removeHash : removeHash;
  var red = parseInt(hex.substring(0, 2), 16);
  var green = parseInt(hex.substring(2, 4), 16);
  var blue = parseInt(hex.substring(4, 6), 16);
  return "rgba(".concat(red, ", ").concat(green, ", ").concat(blue, ", ").concat(opacity / 100, ")");
};

var _default = convertHexToRgba;
exports.default = _default;